import { fortuneWheelApiService } from "../api";
import { authStore, fortuneWheelStore } from "../stores";
import { getCountDown } from "../utils";

class FortuneWheelService {

  setData = async (gameId: number, partnerId: number) => {
    try {
      const wheel = await fortuneWheelApiService.getDailyWheelData(gameId, partnerId, authStore.currency!)
      fortuneWheelStore.setDailyWheelButtonIsVisible(true);
      fortuneWheelStore.setWheelData(wheel);

      // Fetch initial data on app initialization
      const data = await fortuneWheelApiService.getLastSpinData(fortuneWheelStore.wheelData?.id!);
      // Use configuration.participationPeriodSeconds (preferred) or fallback to root level
      const participationPeriod = wheel.configuration?.participationPeriodSeconds || wheel.participationPeriodSeconds || 86400;
      if (getCountDown(data.spin?.createdAt, participationPeriod)) {
        fortuneWheelStore.setLastSpinDate(data.spin?.createdAt);
      }

      // Fetch unused spins on initialization
      const unusedSpins = await fortuneWheelApiService.getUnusedSpins(wheel.id);
      fortuneWheelStore.setUnusedSpins(unusedSpins);

      if (!fortuneWheelStore.lastSpinDate) {
        // fortuneWheelStore.setDailyWheelModalIsOpen(true);
      }
    } catch (error) {
      console.error("Error setting fortune wheel data:", error);
      fortuneWheelStore.setDailyWheelButtonIsVisible(false);
    }
  };

  // Check spin state and fetch necessary data (without LastSpin and UnusedSpins APIs)
  checkSpinState = async (wheelId: number) => {
    try {
      fortuneWheelStore.setLoadingSpinState(true);

      // Fetch user progress only
      // Note: UnusedSpins are updated via SignalR, LastSpin is only called on init and after spinning
      const progress = await fortuneWheelApiService.getUserProgress(wheelId);
      fortuneWheelStore.setUserProgress(progress);
    } catch (error) {
      console.error("Error checking spin state:", error);
    } finally {
      fortuneWheelStore.setLoadingSpinState(false);
    }
  };

  // Refresh last spin date (called after spinning)
  refreshLastSpinDate = async (wheelId: number, usedSpinId: number) => {
    try {
      // Note: Used spin is already removed from array in Wheel component
      // Fetch last spin date after spinning
      const lastSpinData = await fortuneWheelApiService.getLastSpinData(wheelId);
      const wheel = fortuneWheelStore.wheelData;
      if (wheel) {
        const participationPeriod = wheel.configuration?.participationPeriodSeconds || wheel.participationPeriodSeconds || 86400;
        if (getCountDown(lastSpinData.spin?.createdAt, participationPeriod)) {
          fortuneWheelStore.setLastSpinDate(lastSpinData.spin?.createdAt);
        } else {
          fortuneWheelStore.setLastSpinDate(null);
        }
      }

      // Refresh progress after spinning
      await this.checkSpinState(wheelId);
    } catch (error) {
      console.error("Error refreshing last spin date:", error);
    }
  };

}

export const fortuneWheelService = new FortuneWheelService();